import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.967 2.3a2.667 2.667 0 1 0 0 5.333 2.667 2.667 0 0 0 0-5.333m-.943 1.724A1.333 1.333 0 1 1 11.91 5.91a1.333 1.333 0 0 1-1.886-1.886",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.3 3.633a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2a.667.667 0 1 0-1.333 0v2a.667.667 0 0 1-.667.667h-6a.667.667 0 0 1-.667-.667v-6a.667.667 0 0 1 .667-.666h2a.667.667 0 1 0 0-1.334z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })